import React from 'react';

import { Modal, type ModalProps } from '@depop/web-ui-kit/Modal';

import styles from './styles.module.css';

import { ProductImpressionHandler } from '@/components/ProductImpressionHandler';
import { ScrollableItemRow } from '@/components/ScrollableItemRow';
import { SimilarItemsProductCard } from '@/components/SimilarItems/SimilarItemsProductCard';
import { ModuleName } from '@/modules/impressions/types';
import { type SimilarProduct } from '@/modules/similar/aliases';
import { MIN_PRODUCTS_PER_SEGMENT } from '@/modules/similar/constants';

type Props = Pick<ModalProps, 'isOpen' | 'setOpen'> & {
  title: string;
  products?: SimilarProduct[];
  onProductClick?: (product: SimilarProduct, index: number) => void;
};

export function YouMightAlsoLikeModal({
  isOpen,
  setOpen,
  title,
  products = [],
  onProductClick = () => null,
}: Props) {
  return (
    <Modal
      wide
      isOpen={isOpen}
      setOpen={setOpen}
      title={title}
      content={() => (
        <div className={styles.modalProductListContainer}>
          <ScrollableItemRow itemsPerRow={MIN_PRODUCTS_PER_SEGMENT}>
            {products.map((product, index) => {
              return (
                <li key={product.id}>
                  <ProductImpressionHandler
                    index={index}
                    isLastItem={index === products.length - 1}
                    pageNumber={1}
                    moduleName={ModuleName.YouMightAlsoLike}
                  >
                    <SimilarItemsProductCard
                      id={product.id}
                      slug={product.slug}
                      pricing={product.pricing}
                      isBoosted={product.is_boosted}
                      product={product}
                      onClick={(product) => onProductClick(product, index)}
                    />
                  </ProductImpressionHandler>
                </li>
              );
            })}
          </ScrollableItemRow>
        </div>
      )}
    />
  );
}
